import api from ".";
import cookiesModifier from "../utils/cookies";

export const getOrganizations = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`applicants/organizations/consultant/${id}`);
        return res.data;
    } catch (error) {
        throw error;
    }
}